/** Piecewise linear interpolation between anchor points (Excel IF ladder helper). */
export const lerp = (value, anchors) => {
  if (anchors.length === 0) return 0;
  if (value <= anchors[0][0]) return anchors[0][1];
  for (let i = 1; i < anchors.length; i += 1) {
    const [x0, y0] = anchors[i - 1];
    const [x1, y1] = anchors[i];
    if (value <= x1) {
      if (x1 === x0) return y1;
      return y0 + ((value - x0) / (x1 - x0)) * (y1 - y0);
    }
  }
  return anchors[anchors.length - 1][1];
};

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export const blend = (components) => components.reduce((sum, { score, weight }) => sum + score * weight, 0);
